// The store director (?director=1): stages REAL moments in the real sim + renderer for the CrazyGames covers and the
// preview reel — the whole crowd dancing on the Crier's call, a Sneak who misses it ("?"), the Inspector's pop and the
// confetti reveal, an innocent tumbling with the crowd scattering, the Parade with the Golden Capsule. Nothing is faked
// in the picture: the director only decides WHEN things happen (forces a call, holds a Sneak still, aims the Popper),
// then the sim plays it out. Frames are stepped on a fixed clock (game.step) so the video is frame-exact.

import type { Game } from "../game";
import * as M from "../../../shared/map";

type Sim = any;
export class Director {
  constructor(private g: Game) { g.manual = true; document.body.classList.add("director"); g.world.setYou(null); }
  /** the map tables (stalls, drains) for staging */
  readonly map = M;
  get sim(): Sim { return (this.g.feed as any).net.tr.table.sim; }
  get table(): any { return (this.g.feed as any).net.tr.table; }
  step(n = 1, dt = 1 / 30) { for (let i = 0; i < n; i++) this.g.step(dt); }
  cam(x: number, z: number, dist: number, pitchDeg = 55) { this.g.directorCam = { x, z, dist, pitch: (pitchDeg * Math.PI) / 180 }; }
  /** the play phase, now (skip the intro card) */
  skipIntro() { const s = this.sim; if (s.phase === "intro") { s.playAt = s.time; s.phaseAt = s.time - 10; } for (let i = 0; i < 4; i++) this.step(1); }
  /** the Crier calls `kind` right now (the same mechanics as stepCalls: every townie reacts after its own stagger) */
  call(kind: string) {
    const s = this.sim, now = s.time;
    s.call = { id: (s.callSeq = (s.callSeq || 0) + 1), kind, at: now, exposed: 0 };
    s.callNextAt = now + 60;
    for (const b of s.bodies) if (b.brain && b.visible && (b.mode === "free" || b.mode === "panic")) { b.brain.callAt = now + 0.25 + Math.random() * 0.45; b.brain.callKind = kind; }
    for (const st of s.seats) if (st.role === "sneak" && st.body && st.body.visible) { st.callId = s.call.id; st.callDone = false; st.answerAt = -1; s.call.exposed++; }
  }
  /** a Sneak seat stops being driven by its bot (it stands still: it will miss the next call → the "?") */
  hold(seat: number, on = true) { this.table.setDriven(seat, on); }
  sneaks(): any[] { return this.sim.seats.filter((x: any) => x.role === "sneak" && x.body && x.body.visible).map((x: any) => ({ seat: x.i, body: x.body })); }
  inspector(): any { const s = this.sim; return s.seats[s.inspectorSeat]; }
  npcs(): any[] { return this.sim.bodies.filter((b: any) => b.kind === "npc" && b.visible && b.mode === "free"); }
  /** move a body (teleport, for staging) */
  place(b: any, x: number, z: number, h = 0) {
    b.x = x; b.z = z; b.h = h; b.vx = b.vz = 0; b.face = h;
    // a townsperson stands here, looking around (a real routine state) — so a call finds them in place, facing the way set
    if (b.brain) { Object.assign(b.brain, { task: "act", act: "look", until: this.sim.time + 1e6, lookT: this.sim.time + 1e6 }); b.anim = "idle"; }
  }
  /** the Inspector pops body `b` (real resolvePop: catch or miss); he is moved within range first */
  pop(b: any) {
    const s = this.sim, insp = this.inspector();
    this.table.setDriven(insp.i, true);
    insp.cooldownUntil = 0; insp.charges = Math.max(insp.charges, 2);
    s.pop(insp.i, b.id, { x: b.x, y: 0.8, z: b.z });
  }
  /** start a fresh round as a PARADE round (the hourly window), play phase */
  parade() { const s = this.sim; s.wallMs = Date.UTC(2026, 9, 5, 13, 2); s.restartRound(); this.step(2); this.skipIntro(); }
  freshRound() { const s = this.sim; s.wallMs = Date.UTC(2026, 9, 5, 12, 30); s.restartRound(); this.step(2); this.skipIntro(); }
}
